/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Search_SuccessInputs */

const es_tools_gmail_search_success = /** @type {(inputs: Tools_Gmail_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda en Gmail completada`)
};

const en_tools_gmail_search_success = /** @type {(inputs: Tools_Gmail_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gmail search complete`)
};

/**
* | output |
* | --- |
* | "Gmail search complete" |
*
* @param {Tools_Gmail_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_search_success = /** @type {((inputs?: Tools_Gmail_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_search_success(inputs)
	return en_tools_gmail_search_success(inputs)
});
export { tools_gmail_search_success as "tools.gmail.search_success" }